import { captureException } from '@tandemone/observability/browser'
import { useEffect } from 'react'

/** fan an arbitrary set of query errors into Sentry on change. typed as
 * a rest list so callers can pass each query's `.error` directly without
 * building an array literal.
 */
export function useCaptureQueryErrors(...errors: Array<Error | null>): void {
  useEffect(() => {
    for (const error of errors) {
      if (error) captureException(error)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, errors)
}
